import DisabledContract  from "./DisabledContract";

export default DisabledContract;